export const returnElementFromArray = (el, array, type) => {
    for (var x = 0; x < array.length; x++) {
        if (array[x][type] === el) {
            return array[x];
        }
    } return false;
}